// Copyright (c) 2021 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import LaborRates, {getDefaultState as getLaborRatesDefaultState} from './mass-labor-rates';
import t from 'tcomb';

const MassLaborRate = t.struct({
    busyCounter: BusyCounter,
    dealersByLaborType: LaborRates,
    isDealershipModalOpen: t.Boolean
}, 'MassLaborRate');

export const getDefaultState = () =>
    new MassLaborRate({
        busyCounter: getBusyCounterDefaultState(),
        dealersByLaborType: getLaborRatesDefaultState(),
        isDealershipModalOpen: false
    });

export default MassLaborRate;



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-change/state/index.js